export const environment = {
  production: true,
  apiUrl: 'https://truth-api.cmgservicing.com',
  msalConfig: {
    auth: {
      clientId: '3851ad4b-c3aa-4128-a59a-fb703d2f3a8e',
      authority: 'https://login.microsoftonline.com/57d88166-f247-4dee-a6f9-e6359f96ff2c',
    },
    apiScope: 'api://01dea46d-8047-46ff-8dc2-b134756b93c6/adminapiscope',
    graphScope: 'user.read',
    graphUri: 'https://graph.microsoft.com/v1.0/',
  },
};
